(() => {
  'use strict';

  const svgNamespace = 'http://www.w3.org/2000/svg';
  const arrowPattern = /↗[\uFE0E\uFE0F]?/;

  function makeArrow() {
    const icon = document.createElementNS(svgNamespace, 'svg');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('width', '1em');
    icon.setAttribute('height', '1em');
    icon.style.cssText = 'display:inline-block;vertical-align:-.12em;flex:none';

    const stroke = document.createElementNS(svgNamespace, 'path');
    stroke.setAttribute('d', 'M4.5 19.5 19.5 4.5M9.5 4.5h10v10');
    stroke.setAttribute('fill', 'none');
    stroke.setAttribute('stroke', 'currentColor');
    stroke.setAttribute('stroke-width', '1.35');
    stroke.setAttribute('stroke-linecap', 'square');
    stroke.setAttribute('stroke-linejoin', 'miter');
    icon.append(stroke);
    return icon;
  }

  function replaceArrows(root = document.body) {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const matches = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!arrowPattern.test(node.nodeValue || '')) continue;
      if (node.parentElement?.closest('script, style, svg, textarea')) continue;
      matches.push(node);
    }

    for (const node of matches) {
      const parts = node.nodeValue.split(arrowPattern);
      const replacement = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (index) replacement.append(makeArrow());
        if (part) replacement.append(document.createTextNode(part));
      });
      node.replaceWith(replacement);
    }
  }

  replaceArrows();
  document.addEventListener('shopify:section:load', event => replaceArrows(event.target));
})();
(() => {'use strict';function init(root=document){root.querySelectorAll('[data-shopify-photo]').forEach(button=>button.onclick=()=>{const image=document.getElementById('product-image');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.shopifyPhoto;image.alt=button.dataset.alt||'';document.querySelectorAll('[data-shopify-photo]').forEach((b,i)=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button));if(b===button){const counter=document.getElementById('image-counter');if(counter)counter.textContent=String(i+1).padStart(2,'0')+' / '+String(document.querySelectorAll('[data-shopify-photo]').length).padStart(2,'0');}});});root.querySelectorAll('input[name="id"][data-price]').forEach(input=>input.onchange=()=>{const price=document.getElementById('variant-price');if(price)price.textContent=input.dataset.price;});root.querySelectorAll('[data-open-size]').forEach(b=>b.onclick=()=>document.getElementById('size-dialog')?.showModal());root.querySelectorAll('[data-close-size]').forEach(b=>b.onclick=()=>document.getElementById('size-dialog')?.close());}init();document.addEventListener('shopify:section:load',e=>init(e.target));})();